<div class="team-training-responsibles-container py-12">
    <div fxLayoutAlign="space-between center" class="mb-8">
        <h2 class="my-16 font-normal text-lg">{{ 'TEAMS.TRAINING_RESPONSIBLE.TITLE' | translate }} ({{ trainingResponsibles.length }})</h2>

        <app-white-button
            [icon]="'add'"
            [label]="'TEAMS.TRAINING_RESPONSIBLE.BUTTON.ADD'"
            (onClick)="openAddDialog()"
            *ngIf="trainingResponsibles.length && canManageTrainingResponsibles"
        ></app-white-button>
    </div>

    <div class="team-training-responsibles">
        <div fxLayout="row wrap" fxLayoutAlign="flex-start space-between" fxLayoutGap.gt-xs="8px grid" class="pb-8" *ngIf="trainingResponsibles.length; else noTrainingResponsibles">
            <mat-card
                appearance="outlined"
                fxLayout="row"
                fxLayoutAlign="flex-start space-between"
                fxFlex="1 0 calc(100%-8px)"
                fxFlex.gt-xs="1 0 calc(50%-8px)"
                fxFlex.gt-md="1 0 calc(33.33%-8px)"
                class="mb-12 p-0 pr-48 relative team-training-responsible-card-container user-details-card-container mat-elevation-z0"
                *ngFor="let trainingResponsible of trainingResponsibles"
            >
                <div #userAvatar class="pointer">
                    <img class="user-avatar mr-4" *ngIf="trainingResponsible.avatar.src; else initials" [alt]="trainingResponsible.fullName" [src]="trainingResponsible.avatar.src" />
                    <ng-template #initials>
                        <div fxLayoutAlign="center center" class="avatar-initials user-avatar">{{ trainingResponsible.fullName | initials }}</div>
                    </ng-template>
                </div>
                <app-user-details-card [user]="trainingResponsible" [target]="userAvatar" openedFrom="team_admin_space"></app-user-details-card>

                <mat-card-content class="p-12">
                    <h3 class="m-0 font-normal">{{ trainingResponsible.fullName }}</h3>

                    <button
                        class="more-menu"
                        mat-icon-button
                        [matMenuTriggerFor]="moreMenu"
                        aria-label="More"
                        (click)="$event.stopPropagation()"
                        *ngIf="canManageTrainingResponsibles"
                    >
                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                    </button>

                    <mat-menu #moreMenu="matMenu" xPosition="before">
                        <button mat-menu-item aria-label="remove" (click)="openRemoveTrainingResponsibleDialog(trainingResponsible)">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.REMOVE' | translate }}</span>
                        </button>
                    </mat-menu>
                </mat-card-content>
            </mat-card>
        </div>

        <ng-template #noTrainingResponsibles>
            <div fxLayout="column" fxLayoutAlign="center center" class="no-team-training-responsibles-container py-48 px-24 bg-white">
                <mat-icon class="participant-view-illustration" svgIcon="members_illustration"> </mat-icon>
                <h3 class="mt-8 mb-16">
                    {{ 'TEAMS.TRAINING_RESPONSIBLE.LABEL.NO_USERS_YET' | translate }}
                </h3>

                <app-flat-button
                    [icon]="'add'"
                    [label]="'TEAMS.TRAINING_RESPONSIBLE.BUTTON.ADD'"
                    (onClick)="openAddDialog()"
                    *ngIf="canManageTrainingResponsibles"
                ></app-flat-button>
            </div>
        </ng-template>
    </div>
</div>
